import React from 'react'
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";

const Spinner: React.FC<{ loading: boolean }> = ({ loading }) => {
  if (!loading) {
    return <></>
  }

  return (
    <Grid container justifyContent="center" alignContent="center">
      <Box m={2}>
        <CircularProgress/>
      </Box>
    </Grid>
  )
}

export default Spinner;